import { render, staticRenderFns } from "./ExamModalAdd.vue?vue&type=template&id=4000699d&scoped=true&lang=pug"
import script from "./ExamModalAdd.vue?vue&type=script&lang=js"
export * from "./ExamModalAdd.vue?vue&type=script&lang=js"
import style0 from "./ExamModalAdd.vue?vue&type=style&index=0&id=4000699d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000699d",
  null
  
)

export default component.exports